import React, { FunctionComponent } from 'react';
import { Button, ButtonProps } from '@companion-professional/components';
import { cn } from '@companion-professional/webutils';

type PrimaryActionButtonProps = Omit<ButtonProps, 'variant' | 'size'>;

// PrimaryActionButton is the full width, large primary button used for the main call to action at the bottom of a
// checkup page (e.g. "Get Started" on the landing pages or "Back to Checkup" on the help pages).  It takes all the props
// of the shared <Button /> except variant and size.
export const PrimaryActionButton: FunctionComponent<PrimaryActionButtonProps> = ({ className, ...props }) => (
  <Button variant="primary" size="large" className={cn('w-full text-base sm:text-lg', className)} {...props} />
);
